export const extensions = {
    image: [ 'bmp', 'gif', 'jpeg', 'jpg', 'png' ],
    document: [ 'pdf', 'txt' ],
};

export const regularExtensions: string[] = ([] as string[]).concat(...Object.values(extensions));

export const mimeTypes = {
    image: [ 'image/bmp', 'image/gif', 'image/jpeg', 'image/jpg', 'image/png' ],
    document: [
        'application/pdf',
        'text/plain',
    ],
};

export const regularMimeTypes: string[] = ([] as string[]).concat(...Object.values(mimeTypes));

export const mimetypeExtensions: Record<string, string> = {
    'image/bmp': '.bmp',
    'image/x-ms-bmp': '.bmp', // non-standard alias used by older Windows browsers
    'image/gif': '.gif',
    'image/jpeg': '.jpg',
    'image/jpg': '.jpg', // non-standard alias for image/jpeg
    'image/png': '.png',
    'image/webp': '.webp',
    'application/pdf': '.pdf',
    'text/plain': '.txt',
};

// Defined explicitly rather than derived from mimetypeExtensions — multiple MIME types can map to the
// same extension (e.g. image/jpg and image/jpeg both yield .jpg), so explicit canonical values are clearer.
export const extensionMimetypes: Record<string, string> = {
    '.bmp': 'image/bmp',
    '.gif': 'image/gif',
    '.jpg': 'image/jpeg',
    '.png': 'image/png',
    '.webp': 'image/webp',
    '.pdf': 'application/pdf',
    '.txt': 'text/plain',
};

const previewableMimeTypes: Set<string> = new Set([
    ...mimeTypes.image,
    'application/pdf',
]);

export function isPreviewableMimeType(mimeType: string): boolean {
    return previewableMimeTypes.has(mimeType);
}

